<template>
  <NodeEditor
    :node="value"
    :toolbar="toolbar"
    @editFinish="$_savingOptionsMixin_onEditFinish"
    @delete="$_savingOptionsMixin_onDelete"
  >
    <div ref="edit-node" contenteditable="true" @input="onInput"></div>
  </NodeEditor>
</template>

<script>
import NodeEditor from '../NodeEditor/NodeEditor.vue';
import PigeonDocNodeModel from '../../models/PigeonDocNodeModel';

import setCaretToEnd from '../../lib/setCaretToEnd';
import savingOptionsMixin from '../NodeEditor/Mixins/savingOptionsMixin.js';

export default {
  name: 'TextNode',
  inject: ['editBus'],
  mixins: [savingOptionsMixin],
  props: {
    value: PigeonDocNodeModel,
  },
  components: {
    NodeEditor,
  },
  data() {
    return {
      toolbar: ['formatting', 'alignment', 'layout'],
    };
  },
  mounted() {
    this.setText();
    this.$refs['edit-node'].focus();
    setCaretToEnd(this.$refs['edit-node']);
  },
  watch: {
    'value.content': {
      handler() {
        if (this.$refs['edit-node'].innerHTML != this.value.content) {
          this.setText();
        }
      },
    },
  },
  methods: {
    onInput() {
      this.editBus.update({ content: this.$refs['edit-node'].innerHTML });
    },
    setText() {
      this.$refs['edit-node'].innerHTML = this.value.content;
    },
  },
};
</script>
